(function () {
  function moneyFormat(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    return `£${(cents / 100).toFixed(2)}`;
  }

  /* "£20" rather than "£20.00". The pill is read at a glance, and the trailing
     zeros are noise next to the real price sitting beside it. Amounts with
     actual pence keep them. */
  function moneyShort(cents, format) {
    return moneyFormat(cents, format).replace(/([.,])00(?!\d)/, '');
  }

  function initStickyAtc(productInfo) {
    const sectionId = productInfo?.dataset?.section;
    if (!sectionId) return;

    const sticky = document.querySelector(`.tailkind-sticky-atc[data-section-id="${sectionId}"]`);
    if (!sticky || sticky.dataset.initialized === 'true') return;
    sticky.dataset.initialized = 'true';

    /* Re-parent to <body> so position:fixed is resolved against the viewport.
       As rendered, the bar lives inside .product__info-container /
       .product__column-sticky, and .product__info-wrapper may carry an
       `animate--slide-in` transform — any transformed/sticky ancestor becomes
       the containing block for a fixed child, which is what made the bar
       "hover at the bottom of the text column" instead of pinning to the
       screen. Moving it to <body> guarantees viewport-relative positioning. */
    if (sticky.parentElement !== document.body) {
      document.body.appendChild(sticky);
    }

    const addToCartButton = productInfo.querySelector(`#ProductSubmitButton-${sectionId}`);
    const variantInput = sticky.querySelector('[data-sticky-variant-input]');
    const variantTitleEl = sticky.querySelector('[data-sticky-variant-title]');
    const priceEl = sticky.querySelector('[data-sticky-price]');
    const mediaWrapper = sticky.querySelector('[data-media-wrapper]');
    const quantityInput = sticky.querySelector('.quantity__input');
    const moneyFmt = sticky.dataset.moneyFormat || '{{ amount }}';

    /* The bar follows the buybox's purchase-type toggle. Without this it would
       keep quoting the subscription price and the "Subscribe & save" pill while
       the buybox said one-time - the very contradiction the single-decision
       buybox exists to remove. Defaults to subscribe, matching the toggle's own
       default, and is corrected the moment the buybox announces itself. */
    let purchaseMode = 'subscribe';
    let announcedPlanId = '';

    const syncFromVariant = (variant) => {
      if (!variant) return;
      if (variantInput) {
        variantInput.value = variant.id || '';
        variantInput.disabled = !variant.available;
      }
      if (variantTitleEl) {
        variantTitleEl.textContent = variant.title && variant.title !== 'Default Title' ? variant.title : 'One-time purchase';
      }
      /* The bar defaults to the subscription plan (hidden selling_plan input),
         so quote the plan's price - not the one-time price. Without this the
         customer is shown £39.99 and charged £36.39. Falls back to the plain
         price when the product has no subscription plan. */
      if (priceEl) {
        /* Detect the plan by field NAME, not our own data attribute: Seal
           Subscriptions rewrites the selling_plan input and strips custom
           attributes, so `[data-sticky-selling-plan]` silently stops matching. */
        const planField = sticky.querySelector('[name="selling_plan"]');

        /* Each variant has its OWN plan (1-month supply -> monthly plan,
           3-month supply -> 3-monthly plan, ...). The posted plan must follow
           the selected variant, otherwise the form submits a plan that does not
           belong to the variant. Re-point it before reading the price. */
        const forVariant = variantMap[String(variant.id)] || {};
        const ownPlans = Object.keys(forVariant.plan_prices || {});

        if (planField) {
          if (purchaseMode === 'onetime') {
            /* Disabled, not merely emptied: an empty selling_plan is not the
               same as no selling_plan to /cart/add. */
            planField.value = '';
            planField.disabled = true;
          } else {
            /* Prefer the plan the buybox announced; fall back to this variant's
               own first plan. Either way the posted plan must belong to the
               selected variant. */
            let want = announcedPlanId;
            if (!want || (ownPlans.length && !ownPlans.includes(String(want)))) {
              want = ownPlans.length ? ownPlans[0] : '';
            }
            planField.value = want;
            planField.disabled = !want;
          }
        }
        const planId = planField && !planField.disabled && planField.value
          ? String(planField.value)
          : '';

        /* Resolve the plan price from OUR OWN embedded variant data, keyed by
           variant id - never from the passed-in object.

           `variant` here can come from two very different places: our embedded
           JSON (which carries plan_price), or the buybox's `variant:change`
           event, which hands over Shopify's raw variant object with only the
           one-time `price`. Trusting the argument meant every variant change -
           and every mobile load, where the buybox fires that event on init -
           silently fell back to the list price. */
        const mapped = variantMap[String(variant.id)] || {};
        let shown = variant.price;
        if (planId && mapped.plan_prices && typeof mapped.plan_prices[planId] !== 'undefined') {
          shown = mapped.plan_prices[planId];        // exact plan currently posted
        } else if (planId && typeof mapped.plan_price !== 'undefined') {
          shown = mapped.plan_price;                 // first plan, as a fallback
        } else if (typeof mapped.price !== 'undefined') {
          shown = mapped.price;
        }
        if (typeof shown !== 'undefined') {
          priceEl.textContent = moneyFormat(shown, moneyFmt);
        }

        /* Quote the saving on the "Subscribe & save" pill, and keep it tied to
           the variant actually selected - the 3 Month Supply saves £20, the 6
           Month saves £50. Same basis Seal uses in the buybox (compare-at where
           there is one, else the one-time price) so the two agree; showing a
           different number in the bar would read as a pricing error. */
        const planEl = sticky.querySelector('[data-sticky-plan]');
        if (planEl) {
          /* No pill at all on a one-time purchase - it is not a subscription,
             and saying otherwise is how customers end up on a plan they did not
             choose. */
          if (!planId) {
            planEl.hidden = true;
          } else {
            planEl.hidden = false;
            const base = typeof mapped.compare_at === 'number' && mapped.compare_at > mapped.price
              ? mapped.compare_at
              : mapped.price;
            const saving = typeof base === 'number' && typeof shown === 'number' ? base - shown : 0;
            planEl.textContent = saving > 0
              ? `Subscribe & save ${moneyShort(saving, moneyFmt)}`
              : 'Subscribe & save';
          }
        }
      }
      const strings = window.variantStrings || { addToCart: 'Add to cart', soldOut: 'Sold out' };
      const stickyButton = sticky.querySelector(`#StickyProductSubmitButton-${sectionId}`);
      if (stickyButton) {
        stickyButton.disabled = !variant.available;
        const textSpan = stickyButton.querySelector('span');
        if (textSpan) textSpan.textContent = variant.available ? strings.addToCart : strings.soldOut;
      }
      if (mediaWrapper && variant.featured_image && variant.featured_image.src) {
        let img = mediaWrapper.querySelector('img');
        if (!img) {
          img = document.createElement('img');
          img.className = 'tailkind-sticky-atc__image';
          img.alt = variant.featured_image.alt || '';
          mediaWrapper.innerHTML = '';
          mediaWrapper.appendChild(img);
        }
        img.src = variant.featured_image.src.includes('?') ? variant.featured_image.src : `${variant.featured_image.src}&width=160`;
      }
    };

    /* Variant lookup map from the snippet's embedded JSON, so the sticky can
       sync title/price/availability from the hidden input alone — independent
       of whichever event shape the buybox dispatches. */
    /* declared above syncFromVariant's first call; populated just below */
    let variantMap = {};
    try {
      const json = sticky.querySelector('[data-sticky-variants]');
      if (json) {
        JSON.parse(json.textContent).forEach((v) => {
          variantMap[String(v.id)] = v;
        });
      }
    } catch (e) {
      /* non-fatal — falls back to event-driven sync */
    }

    const mainVariantInput = productInfo.querySelector(`#product-form-${sectionId} input[name="id"]`)
      || productInfo.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    const syncFromInput = () => {
      if (!mainVariantInput) return;
      if (variantInput) variantInput.value = mainVariantInput.value;
      const mapped = variantMap[String(mainVariantInput.value)];
      if (mapped) syncFromVariant(mapped);
    };
    if (mainVariantInput) {
      syncFromInput();
      mainVariantInput.addEventListener('change', syncFromInput);
    }

    /* The buybox announces its purchase type on load and on every toggle.
       Re-run the full sync so the price, the plan the bar posts and the pill all
       move together - a bar quoting the subscription price while posting a
       one-off (or the reverse) is a mischarge, not a cosmetic bug. */
    document.addEventListener('tk:purchase-mode', (event) => {
      const detail = event.detail || {};
      purchaseMode = detail.mode === 'onetime' ? 'onetime' : 'subscribe';
      announcedPlanId = detail.planId || '';
      syncFromInput();
    });

    const mainQtyInput = productInfo.querySelector(`#Quantity-${sectionId}`);
    if (mainQtyInput && quantityInput) {
      quantityInput.value = mainQtyInput.value;
      quantityInput.min = mainQtyInput.min || quantityInput.min;
      quantityInput.max = mainQtyInput.max || quantityInput.max;
      quantityInput.step = mainQtyInput.step || quantityInput.step;
      quantityInput.addEventListener('change', () => {
        mainQtyInput.value = quantityInput.value;
        mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /* The custom buybox dispatches `variant:change` (detail.variant); older
       code dispatched `variantChange` (detail.data.variant). Accept both. */
    const handleVariantEvent = (event) => {
      const detail = event.detail || {};
      const variant = detail.variant || (detail.data && detail.data.variant);
      if (!variant) return;
      syncFromVariant(variant);
    };
    document.addEventListener('variant:change', handleVariantEvent);
    document.addEventListener('variantChange', handleVariantEvent);

    /* ---- Visibility.

       Desktop: show once the real buybox ATC has scrolled up and out of the
       viewport, hide when it's back in view.

       Mobile: show from the first paint. The buybox ATC sits roughly 1.5
       screens down on a phone, so the desktop rule meant a customer had to
       scroll ~2 screens before any way to buy appeared. The only reason to
       hide the bar on mobile is that the real ATC is on screen — two Add to
       cart buttons at once is the confusing case, not an early one.

       Computed from live geometry (no latching flags), so it's correct however
       the scroll happened. IntersectionObservers drive the recompute cheaply;
       a rAF-throttled scroll listener is a backstop for programmatic / fast
       scrolls that can skip an observer callback. ---- */
    sticky.setAttribute('aria-hidden', 'true');

    /* Matches the max-width: 749px breakpoint in tailkind-sticky-atc.css —
       keep the two in step if that breakpoint ever moves. */
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const recompute = () => {
      if (!addToCartButton) {
        /* No buybox button to measure against. On mobile the bar is the only
           way to buy without hunting, so show it rather than hide forever. */
        const fallback = mobileQuery.matches;
        sticky.classList.toggle('is-visible', fallback);
        sticky.setAttribute('aria-hidden', fallback ? 'false' : 'true');
        return;
      }
      const vh = window.innerHeight || document.documentElement.clientHeight || 0;
      const r = addToCartButton.getBoundingClientRect();
      const atcInView = r.bottom > 0 && r.top < vh;
      const scrolledPast = r.bottom <= 0; // ATC has left through the top
      const show = mobileQuery.matches ? !atcInView : (scrolledPast && !atcInView);
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        recompute();
        ticking = false;
      });
    };

    if ('IntersectionObserver' in window && addToCartButton) {
      const io = new IntersectionObserver(recompute, { threshold: [0, 1] });
      io.observe(addToCartButton);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    /* Crossing the breakpoint swaps the whole visibility rule, so recompute on
       it directly - resize alone misses a devtools device-mode toggle. */
    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', recompute);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(recompute);
    }
    recompute();
  }

  document.addEventListener('product-info:loaded', (event) => {
    const productInfo = event.target.closest('product-info') || event.target;
    initStickyAtc(productInfo);
  });

  const initAll = () => document.querySelectorAll('product-info').forEach(initStickyAtc);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    // script ran after the DOM was ready (e.g. async/late load) — init now
    initAll();
  }
})();
